import { put, select, takeLatest } from 'redux-saga/effects'
import { getPatientTimelineSelector } from '../selectors/patientTimeline.selector'
import {
  setFilteredItems,
  setFiltersChips,
  setSelectedFilterChipType,
  setShowClearFiltersButton,
} from '../store/timeline.actions'
import { TimelineConstants } from '../store/timeline.constants'
import { IItem, IItems, ITimelineState } from '../store/timeline.types'

const sortItems = (items: IItems): IItems => {
  items.sort((item1, item2) => +new Date(item1.date) - +new Date(item2.date))

  const timelineItems: IItems = []
  items.forEach((item) => {
    if (!item.isEkgImport) {
      timelineItems.push(item)
    }

    if (item.isEkgImport && item.itemType === 'Vitals') {
      timelineItems.push(item)

      if (item.clientEventId && item.vsAction) {
        items.forEach((procItem) => {
          if (procItem.key === item.clientEventId) {
            timelineItems.push(procItem)
          }
        })
      }
    }
  })

  return timelineItems
}

export function* updateFilteredItems() {
  const timeline: ITimelineState = yield select(getPatientTimelineSelector)
  const { selectedFilterChipType, filterChips, items } = timeline
  const filters: string[] = []
  if (selectedFilterChipType === TimelineConstants.CLEAR_FILTERS) {
    filterChips.map((filterChip) => {
      filterChip.isSelected = false
    })
  } else {
    filterChips.map((filterChip) => {
      if (filterChip.filterAction === selectedFilterChipType) {
        filterChip.isSelected = !filterChip.isSelected
      }
      if (filterChip.isSelected) {
        filters.push(filterChip.itemType)
      }
    })
  }

  const sortedItems = sortItems(items)

  if (filters.length) {
    const filteredItems = sortedItems.filter((item: IItem) => filters.indexOf(item.itemType) > -1)
    yield put(setFilteredItems(filteredItems))
    yield put(setShowClearFiltersButton(true))
  } else {
    yield put(setFilteredItems(sortedItems))
    yield put(setShowClearFiltersButton(false))
  }
  yield put(setSelectedFilterChipType(''))
  yield put(setFiltersChips(filterChips))
}

export function* updateFilteredItemsSaga() {
  yield takeLatest(
    [
      TimelineConstants.UPDATE_FILTERED_ITEMS,
      TimelineConstants.FILTER_TIMES,
      TimelineConstants.FILTER_VITALS,
      TimelineConstants.FILTER_PROCEDURES,
      TimelineConstants.FILTER_ECG,
      TimelineConstants.FILTER_ASSESSMENTS,
      TimelineConstants.FILTER_MEDICATIONS,
      TimelineConstants.CLEAR_FILTERS,
    ],
    updateFilteredItems
  )
}
